function filterAlerts(tags: any, alerts: any) {
  const errorArray: any = [];

  alerts.forEach((alert: any) => {
    if (tags.includes(alert.tag)) {
      errorArray.push(alert);
    }
  });

  return errorArray;
}

export default {
  alerts(state: any) {
    return state.alerts;
  },

  // ------------- ALERTAS ------------
  // ============ RECEITAS

  alertsRevenueEvolution(state: any) {
    const tags = [1, 2, 11, 12];

    return filterAlerts(tags, state.alerts);
  },

  alertsJourneys(state: any) {
    const tags = [2, 4, 10];

    return filterAlerts(tags, state.alerts);
  },

  alertsEvolutionPeopleBought(state: any) {
    const tags = [1, 11, 12];

    return filterAlerts(tags, state.alerts);
  },

  alertsSafra(state: any) {
    const tags = [1, 2, 11, 12];

    return filterAlerts(tags, state.alerts);
  },

  // ============ BASE
  alertsGrowth(state: any) {
    const tags = [1, 5, 6, 13, 14, 15, 16];

    return filterAlerts(tags, state.alerts);
  },

  alertsVolume(state: any) {
    const tags = [1, 5, 8, 13, 14];

    return filterAlerts(tags, state.alerts);
  },

  alertsEngagement(state: any) {
    const tags = [1, 6, 7, 15, 16];

    return filterAlerts(tags, state.alerts);
  },
};
